import { useState } from "react";
import { createPortal } from "react-dom";
import { useToasts, type Toast } from "../../store/toasts";
import { Icon } from "./Icon";
import { IconBtn, portalRoot } from "./primitives";

const TONE: Record<string, string> = { success: "good", error: "error", info: "teal", warn: "warn" };
const ICONS: Record<string, string> = { success: "check-circle", error: "warning-circle", info: "info", warn: "warning" };

function ToastCard({ t, onClose }: { t: Toast; onClose: () => void }) {
  const [copied, setCopied] = useState(false);
  const tone = TONE[t.typ] ?? "teal";
  const ic = ICONS[t.typ] ?? "info";
  const col = `var(--${tone === "teal" ? "accent-text" : tone})`;
  const copy = () => {
    if (!t.copy) return;
    void navigator.clipboard?.writeText(t.copy).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    });
  };
  return (
    <div
      className="glass-strong anim-slide-r"
      // role="status" statt "alert": die Vorlesehilfe liest die Meldung zu
      // Ende gesprochener Sätze vor, statt sie zu unterbrechen. Fehler bleiben
      // ohnehin zwölf Sekunden stehen.
      role="status"
      style={{ borderRadius: 14, padding: "13px 15px", boxShadow: "var(--shadow-lg)", display: "flex", gap: 11, alignItems: "flex-start", borderLeft: `3px solid ${col}` }}
    >
      <Icon name={ic} size={19} weight="fill" style={{ color: col, marginTop: 1 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ fontSize: 14, fontWeight: 600 }}>{t.msg}</p>
        {t.detail && (
          <p className={t.mono ? "font-mono" : ""} style={{ fontSize: 12, color: "var(--text-mute)", marginTop: 3, wordBreak: "break-word" }}>
            {t.detail}
          </p>
        )}
        {t.copy && (
          <button
            type="button"
            onClick={copy}
            style={{ marginTop: 7, fontSize: 11.5, fontWeight: 600, color: copied ? "var(--good)" : "var(--accent-text)", background: "none", border: "none", cursor: "pointer", display: "flex", alignItems: "center", gap: 5, padding: 0, fontFamily: "inherit" }}
          >
            <Icon name={copied ? "check" : "copy"} size={13} />
            {copied ? "Kopiert!" : "Meldung kopieren"}
          </button>
        )}
      </div>
      <IconBtn icon="x" size={14} box={24} onClick={onClose} title="Meldung schließen" />
    </div>
  );
}

/** Gehört EINMAL in den Wurzelbaum (App.tsx), nicht je Bildschirm. */
export function Toaster() {
  const toasts = useToasts((s) => s.toasts);
  const removeToast = useToasts((s) => s.removeToast);
  return createPortal(
    <div
      aria-live="polite"
      style={{ position: "fixed", right: 20, bottom: "calc(20px + var(--safe-bottom))", zIndex: 400, display: "flex", flexDirection: "column", gap: 10, maxWidth: 400 }}
    >
      {toasts.map((t) => (
        <ToastCard key={t.id} t={t} onClose={() => removeToast(t.id)} />
      ))}
    </div>,
    portalRoot(),
  );
}
